import { getFeatureFlags } from '@/api'

const DEFAULT_FLAGS = {
  rechargeEnabled: false,
  withdrawEnabled: false,
  marketEnabled: false,
  drawEnabled: false,
  scratchEnabled: false,
  composeEnabled: false,
  cdkEnabled: false,
}

let cache = null
let loading = null

function normalizeFlags(data = {}) {
  return {
    rechargeEnabled: !!data.rechargeEnabled,
    withdrawEnabled: !!data.withdrawEnabled,
    marketEnabled: !!data.marketEnabled,
    drawEnabled: !!data.drawEnabled,
    scratchEnabled: !!data.scratchEnabled,
    composeEnabled: !!data.composeEnabled,
    cdkEnabled: !!data.cdkEnabled,
  }
}

/** 拉取功能开关（审核期默认关闭高风险入口） */
export async function loadFeatureFlags(force = false) {
  if (!force && cache) return cache
  if (!force && loading) return loading
  loading = getFeatureFlags()
    .then((res) => {
      const data = res?.data || res || {}
      cache = normalizeFlags(data)
      return cache
    })
    .catch(() => {
      cache = { ...DEFAULT_FLAGS }
      return cache
    })
    .finally(() => {
      loading = null
    })
  return loading
}

export function getCachedFeatureFlags() {
  return cache || { ...DEFAULT_FLAGS }
}

/** 页面进入守卫：关闭则静默返回首页（不弹 Toast） */
export async function requireFeature(flagKey) {
  const flags = await loadFeatureFlags(true)
  if (!flags[flagKey]) {
    uni.navigateBack({ fail: () => uni.reLaunch({ url: '/pages/home/home' }) })
    return false
  }
  return true
}
